import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=0e991a2a&scoped=true"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=0e991a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e991a2a",
  null
  
)

export default component.exports